interface Props {
  children: React.ReactNode;
  testId?: string;
}

export const ModalDetailBody = ({ children, testId }: Props) => (
  <div
    className="flex flex-col px-6 pb-5"
    {...(testId ? { "data-test-id": testId } : {})}
  >
    {children}
  </div>
);
